"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationsFormTranslator = void 0;
exports.locationsFormTranslator = {
    en: {
        name: "Name",
        nameRequired: "Name is required",
        environment: "Environment",
        description: "Description",
        characters: "Characters",
        mainImage: "Main Image",
        additionalImages: "Additional Images",
        save: "Save",
        notFound: "locationNotFound",
        successMessage: "Success"
    },
    ru: {
        name: "Название",
        nameRequired: "Название обязательно",
        environment: "Окружающая среда",
        description: "Описание",
        characters: "Персонажи",
        mainImage: "Главное изображение",
        additionalImages: "Дополнительные изображения",
        save: "Сохранить",
        notFound: "Локация не найдена",
        successMessage: "Сохранено"
    },
};
